// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"335af314","453":"c8a7b2ae","455":"dde65aa8","977":"79ba5855"}[chunkId] + ".chunk.js";
};